import { Link } from "react-router-dom";

interface MovieCardProps {
  id: number;
  title: string;
  slug: string;
  category: string;
  year: number;
  rating: number;
  poster: string;
  tags: string[];
}

export default function MovieCard({ id, title, slug, category, year, rating, poster, tags }: MovieCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-100">
        <img
          src={poster}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2 bg-background-50/90 backdrop-blur-sm text-primary-500 text-xs font-semibold px-2 py-0.5 rounded-md flex items-center gap-1">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-[10px]"></i>
          </div>
          {rating}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <div className="flex flex-wrap gap-1">
            {tags.slice(0, 2).map((tag) => (
              <span key={tag} className="text-[10px] bg-primary-500/90 text-background-50 px-1.5 py-0.5 rounded">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
      <h3 className="mt-2.5 text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mt-0.5">
        {year}
      </p>
    </Link>
  );
}